/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import EditContentOverlay from "./overlays/editing-overlay";

export default baustein.register("editing-tools", {
    setupEvents(add) {
        add("click", ".editing-tools__button", this._onButtonClick);
    },

    _onButtonClick(event) {
        event.preventDefault();

        var editContentOverlay = new EditContentOverlay({
            contentEditUrl: event.target.href
        });
        editContentOverlay.appendTo(this);
        editContentOverlay.open();
    }
});

